import bs58 from 'bs58'

/** Encode a UUID string to Base58 (~22 chars). Non-UUID input is returned as-is. */
export function encodeId(uuid: string): string {
  if (!uuid || !uuid.includes('-')) return uuid
  const hex = uuid.replace(/-/g, '')
  if (hex.length !== 32) return uuid
  const bytes = new Uint8Array(16)
  for (let i = 0; i < 16; i++) {
    bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16)
  }
  return bs58.encode(bytes)
}

/** Decode a Base58 string to UUID. UUID input (contains hyphens) is returned as-is. */
export function decodeId(id: string): string {
  if (!id || id.includes('-')) return id
  try {
    const bytes = bs58.decode(id)
    if (bytes.length !== 16) return id
    const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`
  } catch {
    return id
  }
}
